import { MuiOtpInput } from 'mui-one-time-password-input';
import { memo } from 'react';

export type VpOtpCodeProps = {
  value: string;
  status?: 'success' | 'error' | 'regular';
  disabled?: boolean;
  onChange: (value: string) => void;
};

const isNumber = (text: string): boolean => !isNaN(Number(text));

export const VpOtpCode = memo<VpOtpCodeProps>(({ value, disabled, status = 'regular', onChange }) => {
  return (
    <MuiOtpInput
      value={value}
      onChange={onChange}
      validateChar={isNumber}
      TextFieldsProps={{
        disabled,
        placeholder: '-',
        InputProps: {
          type: 'tel',
          inputMode: 'numeric',
          className: status,
          sx: {
            borderRadius: 0,
            '& .MuiOutlinedInput-notchedOutline': {
              transition: 'border-color 0.25s ease-in-out',
            },
            '&.regular .MuiOutlinedInput-notchedOutline': {
              borderColor: 'transparency.alpha16',
            },
            '&.success .MuiOutlinedInput-notchedOutline': {
              borderColor: 'success.500',
            },
            '&.error .MuiOutlinedInput-notchedOutline': {
              borderColor: 'danger.500',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderWidth: 1,
              borderColor: 'primary.500',
            },
          },
        },
      }}
      sx={{ gap: 1 }}
      length={6}
    />
  );
});

VpOtpCode.displayName = 'VpOtpCode';
